import React, { useMemo } from 'react';
import { translate } from '@utils/i18n';
import getCustomEventDetailsText from './getCustomEventDetailsText';
import createStrategyRegistry from './strategies';
function VersionDetails({ details, version }) {
    const strategyRegistry = useMemo(() => createStrategyRegistry(), []);
    const isCustomEvent = Object.keys(version.changes).some((key) => key === 'custom_event');
    if (isCustomEvent) {
        const customEventText = getCustomEventDetailsText(version);
        return (React.createElement("div", { className: "versionDetails" }, customEventText || translate('no_details_available', { namespace: 'features.activity_feed' })));
    }
    return (React.createElement("div", { className: "versionDetails" }, details.map((detail) => {
        const strategy = strategyRegistry.getStrategy(detail.key);
        return (React.createElement(React.Fragment, { key: detail.key }, strategy.render(detail.key, detail.newValue, detail.oldValue, version.event)));
    })));
}
export default VersionDetails;
